import React, { useState, useRef, useEffect } from 'react';

export const formatDate = (currentDate) => {
  const d = new Date(currentDate);

  const minutes = convertTwoDigit(d.getMinutes());
  const hours = convertTwoDigit(d.getHours());

  const year = d.getFullYear();
  const month = convertTwoDigit(d.getMonth() + 1);
  const date = convertTwoDigit(d.getDate());

  return `${date}/${month}/${year} ${hours}:${minutes}`;
}
export const formatDate3 = (currentDate) => {
  const d = new Date(currentDate);

  const year = d.getFullYear();
  const month = convertTwoDigit(d.getMonth() + 1);
  const date = convertTwoDigit(d.getDate());

  return `${date}/${month}/${year}`;
}

export const formatDate2 = (currentDate) => {
  const monthNames = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];
  const d = new Date(currentDate);

  const year = d.getFullYear();
  const month = monthNames[d.getMonth()];
  const date = convertTwoDigit(d.getDate());

  return `${date} ${month} ${year}`;
}

const convertTwoDigit = (dt) => {
  const tmpData = dt.toString();

  if (tmpData.length < 2) {
    return `0${tmpData}`;
  }

  return dt;
};


export const formatTime = (currentDate) => {
  const d = new Date(currentDate);

  const minutes = convertTwoDigit(d.getMinutes());
  const hours = convertTwoDigit(d.getHours());

  return `${hours}:${minutes}`;
}


export const formatTime2 = (currentDate) => {
  const d = new Date(currentDate);

  const hours = convertTwoDigit(d.getHours().toString());

  return `${hours}`;
}
export const formatTime3 = (currentDate) => {
  const d = new Date(currentDate);

  const minutes = convertTwoDigit(d.getMinutes().toString());

  return `${minutes}`;
}


export const CountDown = (currentDate) => {

  const d = new Date(currentDate).getTime();
  const now = new Date().getTime();
  const distance = d - now;

  const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((distance % (1000 * 60)) / 1000);

  if (distance < 0) {
    return "-"
  } else {

    return `${hours}:${minutes}`;
  }

}
export const CountdownTimer = (currentDate) => {
  return "Sukses";
}

